// extracted by mini-css-extract-plugin
export default {"day-block":"pCWBt","day-block__weeks":"VD4go","day-block__divider":"ZESrj","day-block__days":"rhurU","day-block__container":"si1ra"};